import { API_URL } from '../../../utils/config';

export const IP_ALLOCATION_PTP_URL = `${API_URL}/ipallocation/ptp`;
